<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="اصنع-فرصك">
<h1><span dir="rtl">اصنعْ فرصَكَ</span></h1>
<p style="text-indent:17px;"><span dir="rtl">نجاحُنا عبارةٌ عن فرصٍ متواليةٍ، يمكنُ للجميعِ أن يجنيها دونَ استثناء، الفقيرُ والغنيُّ، الطّفلُ والكهلُ، السّقيمُ والمعافى، في الصّباح أو المساءِ، اصنعْ لنجاحكَ فرصاً، امنحْ لطموحاتِك الميتةِ نبضاً، ولملمْ حجارتكَ المتناثرةَ، وابدأ ببناءِ بيتِ أحلامِكَ. ستكونُ وحيداً، وقد تتحطّمُ سفينتُك بفعلِ صخورِ اليأسِ تارةً، وقد تهبُّ على شراعكَ نسائمُ الفشلِ تارةً أخرى، ولكنَّ سفينةَ أحلامكَ ستصلُ في النّهايةِ إلى موانئ السّعادة، عندَها ستختفي ظلالُ إخفاقاتِكَ المستمرّةِ عندَ أوّلِ أطيافِ النّجاح، وستُسجَنُ في ذاكرةِ النّسيان. اصنعْ فرصكَ بنفسكَ، فما زالَ قلبُك الصّغيرُ يؤمنُ بقدرتكَ على تحقيقِ أمانيكَ، وكذلكَ أرضكَ ما زالت تنتظرُ سقياكَ لطموحاتكَ، ونهرُك ما زال يترقّبُ فيضَ أحلامكَ. اصنعْ أحلامكَ؛ فسماؤكَ بدونِ نوركَ قد أظلمَت، وأفلاكُك بدون قبسِك قد أفِلت، وروحُك بدونِ أحلامكَ قد فنيَت. امسكْ قلمَكَ، وخطّ أوّلَ سطورِكَ، وأعلِنْ للعالمِ عودتكَ للحياة، لتكُنْ رقماً صعباً في معادلةِ الحياةِ، لتصرخْ بصوتٍ عالٍ: أنا هُنا، وسأصنعُ أحلامي اليومَ، وفي هذه اللّحظةِ، أنا هُنا لأعيدَ كتابةَ سطوري المبعثرةِ، أنا هُنا لبناءِ سفينةِ أحلامي وللإبحار بها إلى موانئِ السّعادة، أنا هُنا لأجمعَ أطيافَ طموحاتي المتشتّتة، أنا هُنا لأكونَ أنا. تذكّرْ أنّ بينَ أحلامكَ الرائعةِ، هُناكَ أنتَ وعملٌ وربٌّ ودعاءٌ وفرصةٌ ستُصنَعُ بيديكَ، فكلمةُ الاستحالةِ قد تُمحى بكلمةٍ "كُنْ" في السّماء، ولكن قبلَ أن تُكتَبَ في السّماءِ يجبُ أن تكتبَها أنتَ في الأرضِ بإيمانكَ التّامِّ بوجودِ فرصةٍ يمكنُ تحقيقُها. تذكّر أنّ هنالكَ هدفاً، وراءَ كلِّ عقبةٍ تعترضُ طريقَك، أو فرصةً تتوافرُ لكَ في حياتكَ. احلمْ بتحقيقِ هدفٍ عظيمٍ، أو انسحبْ، فنحنُ لم نُمنحْ سوى حياةٍ واحدةٍ، كُن قويّاً، وانطلقْ نحوَ هدفكَ، لا تنتظرْ طويلاً خلفَ الأبوابِ المغلقةِ، فقد يُفتَحُ لك بابُ السّعادةِ ولا تراهُ.</span></p>
<p style="text-align: left;padding-top:30px;"><strong><em><span dir="rtl">تستطيع..</span></em></strong></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?04b483f5